<div class="apitest-container" style="max-width:600px;margin:auto;padding:2em;">
	<h2>API Test</h2>
	<div style="display:flex;gap:1em;margin-bottom:2em;">
		<button mat-raised-button color="primary" (click)="testTickets()">Test /api/ticket</button>
		<button mat-raised-button color="accent" (click)="testDownloadFile()">Test Download File</button>
		<button mat-raised-button color="warn" (click)="testStudios()">Test /api/studio</button>
	</div>

	<mat-card *ngIf="tickets">
		<mat-card-title>API Response</mat-card-title>
		<mat-card-content>
			<pre style="white-space:pre-wrap;word-break:break-word;">{{ tickets | json }}</pre>
		</mat-card-content>
	</mat-card>
	<mat-card *ngIf="studios" style="margin-top:2em;">
		<mat-card-title>Studios API Response</mat-card-title>
		<mat-card-content>
			<pre style="white-space:pre-wrap;word-break:break-word;">{{ studios | json }}</pre>
		</mat-card-content>
	</mat-card>
</div>
